import { createReducer, on } from '@ngrx/store';
import * as actions from './global.actions';
import { createInitialGlobalState } from './global.state';

export const globalReducer = createReducer(
    createInitialGlobalState(),
    on(actions.setMobile, (state, { isMobile }) => ({ ...state, isMobile })),
    on(actions.setShowSidebar, (state, { isSideBarShown }) => ({
        ...state,
        isSideBarShown,
    })),
    on(actions.setShowSmallSidebar, (state, { isSmallSideBarShown }) => ({
        ...state,
        isSmallSideBarShown,
    })),
    on(actions.setLanguage, (state, { language }) => ({ ...state, language })),

    on(actions.globalSuccess, (state, newState) => {
        return {
            ...state,
            lastAction: newState.input,
        };
    }),

    on(actions.globalApiFailure, (state, newState) => {
        return {
            ...state,
            lastFailAction: newState.key,
        };
    }),

    on(
        actions.setOrganization,
        actions.setOrganizations,
        actions.setCurrentOrganizationId,
        actions.setServices,
        actions.setCurrentActiveIntegrations,
        (state, newState) => ({ ...state, ...newState }),
    ),
);
